import { ReactElement, useCallback, useRef, useState } from 'react';

export const EditableTextField = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}): ReactElement => {
  const [isContentEditable, setIsContentEditable] = useState(false);
  const ref = useRef<HTMLHeadingElement>(null);

  const onBlur = useCallback(() => {
    setIsContentEditable(false);
    const val = ref.current?.innerText;
    if (val && val !== value) {
      onChange(val);
    }
  }, [onChange, value]);

  return (
    <button
      className="px-3 py-2 w-full text-left not-focus-within:hover:bg-grey-t-900 focus:bg-background-secondary active:shadow-focused-dark rounded-xs focus-within:outline-2 focus-within:-outline-offset-1 focus-within:outline-white"
      onClick={(e) => {
        setIsContentEditable(true);

        setTimeout(() => {
          if (ref.current) {
            let range: Range | null = null;

            // eslint-disable-next-line
            if (document.caretPositionFromPoint) {
              const caretPosition = document.caretPositionFromPoint(
                e.clientX,
                e.clientY
              );

              if (caretPosition) {
                range = document.createRange();

                range.setStart(caretPosition.offsetNode, caretPosition.offset);

                range.collapse(true);
              }
              // eslint-disable-next-line
            } else if (document.caretRangeFromPoint) {
              range = document.caretRangeFromPoint(e.clientX, e.clientY);
            }

            if (range) {
              const selection = window.getSelection();
              if (selection) {
                selection.removeAllRanges();

                selection.addRange(range);
              }
            }

            ref.current.focus();
          }
        }, 0);
      }}
    >
      <h1
        ref={ref}
        className="text-h1-small font-semibold outline-none"
        suppressContentEditableWarning={true}
        contentEditable={isContentEditable}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();

            ref.current?.blur();
          }
        }}
        onBlur={() => onBlur()}
      >
        {value}
      </h1>
    </button>
  );
};
